<template>
  <div>
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSuccess" :message="message" />

    <div v-if="listLoading" class="text-center py-4">
      <loader />
    </div>

    <div v-else class="row">
      <!-- Current account managers -->
      <div class="col-12 mb-3">
        <label class="form-label">مديرين الحساب الحاليون:</label>
        <div v-if="!currentManagers.length" class="alert alert-info mb-0">
          لا يوجد مديرين حساب مرتبطون بهذا العميل حالياً
        </div>
        <ul v-else class="list-group">
          <li v-for="mgr in currentManagers" :key="mgr.id" class="list-group-item d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <img v-if="mgr.avatar" :src="MEDIA_URL + mgr.avatar" class="rounded-circle me-2" style="width:32px;height:32px;object-fit:cover;" alt="">
              <div>
                <div class="fw-bold">{{ mgr.name }}</div>
                <div class="text-muted small">
                  {{ mgr.email }}
                  <span v-if="mgr.mobileNumber"> - {{ mgr.mobileNumber }}</span>
                </div>
              </div>
            </div>
            <button
              v-if="canEdit"
              type="button"
              class="btn btn-sm btn-outline-danger"
              @click="removeManager(mgr.id)">
              <i class="bi bi-x-lg"></i> إزالة
            </button>
          </li>
        </ul>
      </div>

      <!-- Assign new managers -->
      <div v-if="canEdit" class="col-12">
        <label class="form-label">تعيين مديرين حساب (اختر واحد أو أكثر):</label>
        <div class="border rounded p-2" style="max-height: 260px; overflow-y: auto;">
          <div v-if="!allManagers.length" class="text-muted small p-2">لا يوجد مديرون حساب متاحون حالياً</div>
          <div
            v-for="mgr in allManagers"
            :key="mgr.id"
            class="form-check py-1 border-bottom">
            <input
              type="checkbox"
              class="form-check-input"
              :id="`mgr-check-${mgr.id}`"
              :value="mgr.id"
              v-model="selectedManagerIds"
            />
            <label class="form-check-label w-100" :for="`mgr-check-${mgr.id}`">
              {{ mgr.name }} ({{ mgr.email }}<span v-if="mgr.mobileNumber"> - {{ mgr.mobileNumber }}</span>)
            </label>
          </div>
        </div>
        <div class="mt-3 text-end">
          <button v-if="!saveLoading" type="button" class="btn btn-success" @click="saveManagers">حفظ مديرين الحساب</button>
          <loader v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';
import { mapGetters } from 'vuex';

export default {
  name: 'AccountManagersPanel',
  props: {
    userId: {
      type: [Number, String],
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  data(){
    return {
      listLoading: true,
      saveLoading: false,
      hasError: false,
      hasSuccess: false,
      message: '',
      errorNumber: 0,
      currentManagers: [],
      allManagers: [],
      selectedManagerIds: [],
    }
  },
  computed: {
    ...mapGetters(['MEDIA_URL']),
  },
  methods: {
    checkAccess,
    async loadData(){
      this.listLoading = true;
      this.hasError = false;
      try {
        const clientRes = await this.$http.get(`/api/admin/users/retrieve/${this.userId}`);
        this.currentManagers = clientRes.data.row.AccountManagers || [];
        this.selectedManagerIds = this.currentManagers.map(m => m.id);

        if(this.canEdit){
          const managersRes = await this.$http.get('/api/admin/admins/accountManagers/list');
          this.allManagers = managersRes.data.admins || [];
        }
      } catch(err) {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      }
      this.listLoading = false;
    },
    saveManagers(){
      this.saveLoading = true;
      this.hasError = false;
      this.hasSuccess = false;
      this.$http.put(`/api/admin/users/${this.userId}/accountManagers`, {
        managerIds: JSON.stringify(this.selectedManagerIds),
      }).then(({data}) => {
        this.currentManagers = data.accountManagers || [];
        this.selectedManagerIds = this.currentManagers.map(m => m.id);
        this.message = 'تم حفظ مديرين الحساب بنجاح';
        this.hasSuccess = true;
        toast('تم حفظ مديرين الحساب بنجاح', 'success');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }).finally(() => {
        this.saveLoading = false;
      });
    },
    removeManager(id){
      this.selectedManagerIds = this.selectedManagerIds.filter(mId => mId !== id);
      this.saveManagers();
    },
  },
  created(){
    this.loadData();
  },
  watch: {
    userId(){
      this.loadData();
    }
  }
}
</script>